import { InvoiceBillingType } from './InvoiceBillingType'
import { InvoiceItem } from './InvoiceItem'
import { InvoiceStatus } from './InvoiceStatus'
import { Model } from './Model'
import { invoices } from '@/services'
import { InvoiceDataType } from '@/types'

export class Invoice extends Model {
    static endpoint = 'api/v1/invoices/issued'

    raw: InvoiceDataType

    accounting_period: Date

    due_date?: Date

    invoice_date: Date

    type: InvoiceBillingType

    payment_status: InvoiceStatus

    invoice_number: string

    policy_total_count: number

    battery_total_count: number

    panel_total_count: number

    total_price: number

    amount_paid: number

    balance_due: number

    company_name?: string

    company_unique_id?: string

    invoice_term?: string

    items?: InvoiceItem[]

    constructor(data: InvoiceDataType) {
        super(data)
        this.raw = data
        this.accounting_period = Model.toDate(data.accounting_period) as Date
        this.due_date = Model.toDate(data.due_date)
        this.invoice_date = Model.toDate(data.invoice_date) as Date
        this.type = InvoiceBillingType.find(data.type)
        this.payment_status = InvoiceStatus.find(data.payment_status)
        this.invoice_number = data.invoice_number.toString()
        this.policy_total_count = data.policy_total_count
        this.battery_total_count = data.battery_total_count
        this.panel_total_count = data.panel_total_count
        this.total_price = data.total_price
        this.balance_due = data.balance_due
        this.amount_paid = data.total_price - data.balance_due
        this.company_name = data.company_name
        this.company_unique_id = data.company_unique_id
        this.invoice_term = data.invoice_term
        this.items = data.items?.map(item => new InvoiceItem(item)) || []
    }

    download() {
        return Invoice.download([this])
    }

    static download(items: Invoice[] | string[] = [], filters = {}) {
        const ids = items.length
            ? items.map(item => typeof item === 'string' ? item : item.id)
            : []
        return invoices.download(ids, filters)
    }
}
